export default __webpack_public_path__ + "static/media/openPackage.28c5b67d.svg";